// import React,{ useEffect } from 'react';
// import { useGetAuthrization } from './redux/hooks';
// import { redirectUrl } from '../../common/apiConfig';
// import { datadogRum } from '@datadog/browser-rum';
// export default function App({ children }) {
//   const { auth } = useGetAuthrization();

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       if (!auth.cognitoIdToken) {
//         window.location.assign(redirectUrl);
//       }
//     }, 2000);
//     return () => clearTimeout(timeoutId);
//   }, [auth]);
//   if(auth && auth.user){
//     datadogRum.setUser({
//       ...auth.user
//     })
//   }
//   return (
//     <div className="home-app">
//       <div className="page-container">{children}</div>
//     </div>
//   );
// }


import React, { useEffect } from 'react';
import { useGetAuthrization } from './redux/hooks';
import { redirectUrl } from '../../common/apiConfig';
import { datadogRum } from '@datadog/browser-rum';
import { useDispatch } from 'react-redux';
import { getAuthrization } from './redux/getAuthrization';
import { refreshTokensOnce } from '../../common/authService';

let isRedirecting = false;

function forceReLogin() {
  if (isRedirecting) {
    return;
  }

  isRedirecting = true;

  try {
    sessionStorage.clear();
  } catch (error) {
    // Ignore storage failures
  }

  try {
    localStorage.removeItem('persist:root');
  } catch (error) {
    // Ignore storage failures
  }

  window.location.replace(redirectUrl);
}

export default function App({ children }) {
  const dispatch = useDispatch();
  const { auth } = useGetAuthrization();

  useEffect(() => {
    if (!auth.refreshToken || !auth.expiresAt) {
      return undefined;
    }

    const refreshBeforeExpiryMs = 60 * 1000;
    const delay = Math.max(
      auth.expiresAt - Date.now() - refreshBeforeExpiryMs,
      0,
    );

    const timeoutId = setTimeout(() => {
      refreshTokensOnce(auth.refreshToken)
        .then(tokens => {
          dispatch(getAuthrization({
            ...auth,
            cognitoIdToken: tokens.id_token,
            accessToken: tokens.access_token,
            refreshToken: tokens.refresh_token || auth.refreshToken,
            expiresAt: Date.now() + tokens.expires_in * 1000,
          }));
        })
        .catch(() => {
          forceReLogin();
        });
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [auth.expiresAt, auth.refreshToken, dispatch]); // eslint-disable-line

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!auth.cognitoIdToken) {
        forceReLogin();
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [auth.cognitoIdToken]);

  if (auth && auth.user) {
    datadogRum.setUser({
      ...auth.user,
    });
  }

  return (
    <div className="home-app">
      <div className="page-container">{children}</div>
    </div>
  );
}

